<template>
  <div>
    <div v-if="isLogin">
      <a>
        <AvatarDropdown :current-user="currentUser" />
      </a>
    </div>
    <div v-else class="lens-user-login-btn" @click="userLogin()">
      <a class="user-btn">
        <span class="lens-icon" style=""> <a-icon type="login" />登录 </span>
      </a>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import AvatarDropdown from "./AvatarDropdown.vue";

export default {
  name: "RightContent",
  components: {
    AvatarDropdown,
  },
  computed: {
    // 是否登录
    isLogin() {
      return !!(
        store.getters.token
         || localStorage.getItem("Access-Token")
      );
    },
    // 当前用户信息
    currentUser() {
      return {
        accountId: store.getters.accountId,
        userName: store.getters.userName,
        accountType: store.getters.accountType
      };
    },
  },
  methods: {
    userLogin() {
      this.$emit("userLogin");
    },
  },
};
</script>
